export default {
  text: {
    default: '#db3a1b',
    hover: '#AB331A',
    active: '#8A230D',
    strong: '#631101',
  },
  background: {
    default: '#db3a1b',
    weak: '#fbece5',
    hover: '#ab331a',
    active: '#8a230d',
  },
  border: {
    default: '#db3a1b',
    weak: '#fbece5',
    hover: '#ab331a',
    active: '#8a230d',
  },
  icon: {
    default: '#db3a1b',
    hover: '#AB331A',
    active: '#8A230D',
    strong: '#631101',
  },
};
